import script from "./DigitalHuman.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitalHuman.vue?vue&type=script&setup=true&lang=js"

import "./DigitalHuman.vue?vue&type=style&index=0&id=560c7095&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560c7095"]])

export default __exports__